import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.667 8H8V3.333c0-.4-.267-.666-.667-.666-3.333 0-6 2.666-6 6s2.667 6 6 6 6-2.667 6-6c0-.4-.266-.667-.666-.667M10 1.333c-.4 0-.667.267-.667.667v4c0 .4.267.667.667.667h4c.4 0 .667-.267.667-.667 0-2.6-2.067-4.667-4.667-4.667"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })